import { Component } from '@angular/core';
import {
   Router,
   NavigationStart,
} from '@angular/router';

import { environment } from './http';

import { BrandingService } from '@library/common/branding';
import {
   BreakpointService,
   BrowserCheckService,
   EnvironmentService,
   ErrorMessageService,
   GoogleAnalyticsService,
   PrefetchService,
   TextService,
} from '@library/core/services';

import { AppConfigService } from '@library/app.config';

@Component({
   selector: 'app-root',
   template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
   constructor(
      public router: Router,
      private error: ErrorMessageService,
      private e: EnvironmentService,
      private gtag: GoogleAnalyticsService,
      private brand: BrandingService,
      private check: BrowserCheckService,
      private breakpoints: BreakpointService,
      private text: TextService,
      private prefetch: PrefetchService,

      private appConfig: AppConfigService,
   ) {
      this.e.environment = environment;
      this.gtag.load( environment?.gtagId );
      this.breakpoints.tap();
      this.check.check();

      // console.log( 'requesting server', this.server );
      this.brand.portal = '4PL';
      this.brand.load();
      // if ( environment.production ) { this.brand.load(); }

      // switch on account
      this.appConfig.load( 'hawaiianair' );

      this.text.loginTitle = `Ship and Track with Our 4PL Portal`;
      this.text.loginSubTitle = `Designed to bring business value to you,
         Our 4PL Portal will provide access to vital information on all your shipments.
         Log in today to book or track your freight.`;

      this.prefetch.items = [
         'servicelevels',
         'currencies',
         'countries',
      ];

      const whitelist = [
         '/error',
         '/termsagree',
      ];

      this.router.events.subscribe( event => {
         if ( event instanceof NavigationStart && !whitelist.includes( event.url )) {
            this.error.resetErrors();
         }
      });
   }
}
